"use strict";
exports.__esModule = true;
var pathMapper = {
    "praxisplay": "/praxisplay/role-play"
};
exports["default"] = pathMapper;
